module.exports = __webpack_public_path__ + "static/media/Yina Turchetti.78ab15cf.png";